import { Injectable } from '@angular/core';
import { Product } from '@shared/models/products.model';
import { ProductsBaseService } from '../products-base.service';
import { ProductsTransformService } from '../products-transform.service';
import { generateProductAbout } from '../about/generate-about';

@Injectable({
  providedIn: 'root'
})
export class GetProductAboutCommand {
  constructor(
    private productsBase: ProductsBaseService,
    private productsTransform: ProductsTransformService,
  ) {}

  async execute(id: string) {
    const product = this.productsBase.findProductById(this.productsBase.products, id);
    const subtitle = this.productsTransform.getProductInfo(product, product.productType);
    const { data, title } = generateProductAbout(product);

    return { title, subtitle, data };
  }
}
